import React from "react";
import { Resizable } from "re-resizable";

interface DesignerSnResizableProps {
  direction: "height" | "width";
  seq: number;
  size: string | number;
  onResizeStop: (seq: number, newSize: number) => void;
  minWidth?: number;
  minHeight?: number;
  enable?: { [key: string]: boolean };
  children?: React.ReactNode;
}

export default function DesignerSnResizable({
  direction,
  seq,
  size,
  onResizeStop,
  minWidth,
  minHeight,
  enable,
  children,
}: DesignerSnResizableProps) {
  const handleResizeStop = (
    event: MouseEvent | TouchEvent,
    dir: string,
    ref: HTMLElement,
    delta: { width: number; height: number }
  ) => {
    const newSize = direction === "height" ? ref.offsetHeight : ref.offsetWidth;

    onResizeStop(seq, newSize);
  };

  return (
    <Resizable
      size={direction === "height" ? { height: size } : { width: size }}
      minWidth={minWidth}
      minHeight={minHeight}
      onResizeStop={handleResizeStop}
      enable={enable}
    >
      {children}
    </Resizable>
  );
}
